// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"d05fa492","355":"8c77346a","409":"afc22caf","615":"bdf923a5","694":"f460e609","718":"d1ae5569"}[chunkId] + ".chunk.js";
};